import * as React from 'react';

const ReportContext = React.createContext({});

export default ReportContext;
